import script from "./PaperStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./PaperStatus.vue?vue&type=script&setup=true&lang=js"

import "./PaperStatus.vue?vue&type=style&index=0&id=c2659ad8&lang=scss"

const __exports__ = script;

export default __exports__